import React, { useEffect, useMemo, useState } from "react";
import MiniCard from "../../Vip/components/miniCard";
import { useTranslation } from "react-i18next";
import { getGiftList, getUsedGiftList } from "../../../api/getApi";
import NowGame from "./nowGame";
import useTransferMode from "../../../hook/useTransferMode";
import UsedRewardCard from "../../Rewards/components/usedRewardCard";
import { FaAngleDoubleRight } from "react-icons/fa";
import RewardList from "./rewardList";
const LevelDetail = () => {
  const { t } = useTranslation();
  const i18n_rewards = (key) => t(`reward.${key}`);

  const isTransferMode = useTransferMode();

  return (
    <section className="flex flex-col gap-[10px]">
      {!isTransferMode && <NowGame />}
      <MiniCard />

      <RewardList />
    </section>
  );
};

export default LevelDetail;
